const PLAYLIST_URL_REGEX =
  /^https?:\/\/open\.spotify\.com\/(?:intl-[a-zA-Z-]+\/)?playlist\/([A-Za-z0-9]{22})\/?(?:[?#].*)?$/
const PLAYLIST_URI_REGEX = /^spotify:playlist:([A-Za-z0-9]{22})$/
const SPOTIFY_ID_REGEX = /^[A-Za-z0-9]{22}$/

export const cutPlaylistId = (input: string): string | null => {
  const value = input.trim()
  const match =
    value.match(PLAYLIST_URL_REGEX) ?? value.match(PLAYLIST_URI_REGEX)
  if (match) {
    return match[1]
  }

  if (SPOTIFY_ID_REGEX.test(value)) {
    return value
  }

  return null
}
